import { DiToken } from '@bcf-vanilla-ts-v1-shared/di/di-token';
import type { FooterLicenseCustomComponentLoaderFn } from './types';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const FOOTER_LICENSE_CUSTOM_COMPONENT: DiToken<FooterLicenseCustomComponentLoaderFn | undefined> = new DiToken<
  FooterLicenseCustomComponentLoaderFn | undefined
>('FOOTER_LICENSE_CUSTOM_COMPONENT', {
  factory: () => undefined
});
